import $http from "../../axios";import {Notification, MessageBox} from 'element-ui';

export async function fetchUsers({ commit, state }) {
    let params =  { params: state.users_params }
    await $http
        .get("/api/usuarios", params)
        .then(response => {
            commit("setUsers", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("modelError", error.message);
        });
}
export async function fetchUserDocumentsReport({commit, state}) {
    state.loading.module = true;
    await $http.get('/api/reporte-usuario-documents',{params : state.params}).then((response) => {
        state.loading.module = false;
        commit('setReport', response.data)
    })
        .catch((error) => {
            state.loading.module = false;
            Notification.error({
                title: 'Error!',
                message: error.response.data.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });
        })
}



// WEBPACK FOOTER //
// ./src/modules/report-user-document/actions.js